import {
  generateItemsReducer,

  generateItemAndActionsFromStore,
  generateItemListAndActionsFromStore,
} from "./item";

const itemType = "documentSetDocumentRelation";
const endpoint = "document_set_document_relations/";

export const documentSetDocumentRelationsReducer = generateItemsReducer<DocumentSetDocumentRelationSnakeModel, {}>(itemType);

export const documentSetDocumentRelationAndActionsFromStore = generateItemAndActionsFromStore<DocumentSetDocumentRelationSnakeModel, {}, {}>(
  itemType,
  endpoint,
  (a, b, c, d) => ({}),
);

export const documentSetDocumentRelationListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, documentSetDocumentRelationAndActionsFromStore);
